import React, { useState, useEffect } from 'react';
import { getHotResources } from '../services/api';

function HotResources() {
  const [hotResources, setHotResources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHotResources = async () => {
      try {
        setLoading(true);
        const resources = await getHotResources();
        setHotResources(resources || []);
        setError(null);
      } catch (error) {
        console.error('获取热门资源失败:', error);
        setError('无法获取热门资源');
        setHotResources([]);
      } finally {
        setLoading(false);
      }
    };

    fetchHotResources();
  }, []);

  const handleResourceClick = (link) => {
    if (link) {
      window.open(link, '_blank');
    }
  };

  if (loading) return <div className="loading">正在加载资源...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!hotResources.length) return null;

  return (
    <div className="hot-resources-grid">
      {hotResources.map((resource, index) => (
        <button 
          key={index} 
          className="hot-resource-button"
          onClick={() => handleResourceClick(resource.link)}
          disabled={!resource.link}
        >
          {resource.title || `资源 ${index + 1}`}
        </button>
      ))}
    </div>
  );
}

export default HotResources; 